module.exports = __webpack_public_path__ + "img/versapay-workshops-1.77a9b079.png";